module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAHklEQVR42mNgGHbgP5GYdgYQazj9DRi1fSCjbggAADl0K9Xj0B5TAAAAAElFTkSuQmCC"